import React from 'react';
import {
  AllToolsNavWrapper,
  AllToolsSideNavLinkWrapper,
  AllToolsSideNavLinkInnerWrapper,
} from './styles';
import { SideNavLinkTitleWrapper } from '../styles';
import { SvgIcon } from 'src/commons/components/SvgIcon/SvgIcon';
import { useConsolidatedNavContext } from 'src/providers/ConsolidatedNavContextProvider';
import { NavMetricPublisher } from 'src/commons/utils/metrics';
import SideNavLinkFeatures from 'src/features/nav/components/ConsolidatedSideNav/SideNavLinkFeatures/SideNavLinkFeatures';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import { chromeComponents } from 'src/constants';
import { ToolbarItem } from '@amzn/aac-chrome-internal-api';
import { useInterstitialModalIntercept } from '../InterstitialModal/useInterstitialModalIntercept';
import { getFirstSideNavLink } from 'src/features/nav/utils/toolbarItemLinks';

const AllToolsPanelButton: React.VFC<{ toolbarItem: ToolbarItem }> = ({
  toolbarItem,
}) => {
  const { setOpenModalAppName } = useConsolidatedNavContext();
  const tryInterceptInterstitial = useInterstitialModalIntercept();

  const targetUrl = toolbarItem?.sidebarGroups?.[0]?.links?.[0]?.link?.url;
  const appName = toolbarItem?.sidebarGroups?.[0]?.links?.[0]?.appName ?? '';

  const onClickHandler = () => {
    if (!toolbarItem) {
      return;
    }
    NavMetricPublisher.publishCounterMonitor(
      `toolbarItemClicked-${toolbarItem?.id}`,
      1,
    );
    if (tryInterceptInterstitial(targetUrl, appName)) {
      return;
    }
    setOpenModalAppName(appName);
  };

  if (!toolbarItem) {
    return null;
  }
  const firstLink = getFirstSideNavLink(toolbarItem);
  if (!firstLink) {
    return null;
  }
  const { link, id: linkId } = firstLink;

  const { label: title, url } = link;

  return (
    <AllToolsSideNavLinkWrapper>
      <AllToolsSideNavLinkInnerWrapper
        isSelected={false}
        data-ccx-e2e-id={linkId}
        aria-label={title}
        onClick={onClickHandler}
        {...getTaktAttributes(linkId, chromeComponents.ALL_TOOLS_NAV, {
          url: url,
        })}
      >
        <SvgIcon
          iconPath={toolbarItem.iconPath}
          ariaLabel={title}
          isSelected={false}
        />
        <AllToolsNavWrapper>
          <SideNavLinkTitleWrapper>{title}</SideNavLinkTitleWrapper>
          <SideNavLinkFeatures sideNavLink={firstLink} isFocusable />
        </AllToolsNavWrapper>
      </AllToolsSideNavLinkInnerWrapper>
    </AllToolsSideNavLinkWrapper>
  );
};

export default AllToolsPanelButton;
